<template>
  <div class="dashboard-wrapper" :class="{'sidebar-open': sideOpen, 'side-modal-open': sideModalOpen}">
    <dashboard-sidebar></dashboard-sidebar>
    <transition name="slide-to-left">
      <side-modal v-if="sideModalOpen"></side-modal>
    </transition>
    <transition name="fade">
      <sidebar-overlay v-if="sideOpen || sideModalOpen"></sidebar-overlay>
    </transition>
    <main>
      <dashboard-header></dashboard-header>
      <div class="dashboard-content">
        <div class="page-header mb-20 pl-20">
          <div class="row">
            <div class="col-sm-6">
              <h3 class="page-title">Transactions</h3>
            </div>
            <div class="col-sm-6">
              <div class="screen-controls"></div>
            </div>
          </div>
        </div>
        <div class="kp-flat-card small-shadow">
          <h1>This is h1</h1>
          <h2>This is h2</h2>
          <h3>This is h3</h3>
          <h4>This is h4</h4>
          <h5>This is h5</h5>
          <h6>This is h6</h6>

          <div class="mb-20">
            <button class="btn">Button</button>
          </div>
          <div class="mb-20">
            <button class="btn btn-wider">Button wider</button>
          </div>

          <div class="mb-20">
            <button class="btn btn-outline">Outline button</button>
          </div>

          <div class="mb-20 p-20" style="background-color: gray;">
            <button class="btn btn-outline all-white">All white button</button>
          </div>

          <div class="mb-20">
            <button class="btn btn-plain">Plain button</button>
          </div>

          <div class="mb-20">
            <button class="btn btn-icon">
              <span class="btn-text">
                Icon button
                <i class="uil-arrow-right"></i>
              </span>
            </button>
          </div>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
import moment from 'moment'
import { mapFields } from 'vuex-map-fields'
import DashboardHeader from '@/components/dashboard/DashboardHeader.vue'
import DashboardSidebar from '@/components/dashboard/DashboardSidebar.vue'
import SidebarOverlay from '@/components/dashboard/SidebarOverlay.vue'
import SideModal from '@/components/dashboard/SideModal.vue'
import transactionsData from '@/data/transactions.json'

export default {
  computed: {
    ...mapFields({
      user: 'user',
      sideOpen: 'ui.dashSideOpen',
      sideModalOpen: 'ui.sideModalOpen'
    })
  },
  components: {
    DashboardHeader,
    DashboardSidebar,
    SideModal,
    SidebarOverlay
  }
}
</script>
